import { Component } from 'react';
import PropTypes from 'prop-types';

class AppComponent extends Component {
  static get contextTypes() {
    return {
      app: PropTypes.any,
    };
  }

  get app() {
    if (!this.context) {
      throw new Error('this.context is not defined.  You probably need to makes ure you are passing context to the super call in the constructor.');
    }
    return this.context.app;
  }

  get appContext() {
    this._appContext = this._appContext || {
      app: this.app,
    };
    return this._appContext;
  }
}

export default AppComponent;



// WEBPACK FOOTER //
// ./src/components/core/AppComponent.js